export default "__VITE_ASSET__B8bf9A7x__"